import { render } from "./CategoryPreview.vue?vue&type=template&id=39ab30d5"
import script from "./CategoryPreview.vue?vue&type=script&lang=js"
export * from "./CategoryPreview.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__